import { supabase } from './supabase';

// scrie o actiune in audit_log_v2
export const logAuditEvent = async ({
  actionType,
  actionDescription,
  entityType,
  entityId,
  entityName,
  oldValues = null,
  newValues = null,
  metadata = null,
}) => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    const { data: profile } = await supabase
      .from('profiles_v2')
      .select('nume, prenume, rol')
      .eq('id', user.id)
      .single();

    const { error } = await supabase
      .from('audit_log_v2')
      .insert({
        user_id: user.id,
        user_email: user.email,
        user_name: profile ? `${profile.prenume} ${profile.nume}` : user.email,
        user_role: profile?.rol || 'unknown',
        action_type: actionType,
        action_description: actionDescription,
        entity_type: entityType,
        entity_id: String(entityId),
        entity_name: entityName,
        old_values: oldValues,
        new_values: newValues,
        metadata: metadata,
        user_agent: navigator.userAgent,
      });

    if (error) {
      console.error('Error logging audit event:', error);
    }
  } catch (err) {
    // eroarea nu intrerupe fluxul principal
    console.error('Audit log error:', err);
  }
};

// actiuni frecvente
export const auditActions = {
  // cereri de credite
  approveRequest: (request, creditsAwarded) => logAuditEvent({
    actionType: 'APPROVE',
    actionDescription: `Cerere aprobată cu ${creditsAwarded} credite`,
    entityType: 'credit_request',
    entityId: request.id,
    entityName: request.nume_activitate,
    oldValues: { status: 'in_asteptare' },
    newValues: { status: 'validat', credite_acordate: creditsAwarded },
    metadata: { id_elev: request.id_elev },
  }),

  rejectRequest: (request, reason) => logAuditEvent({
    actionType: 'REJECT',
    actionDescription: `Cerere respinsă: ${reason}`,
    entityType: 'credit_request',
    entityId: request.id,
    entityName: request.nume_activitate,
    oldValues: { status: 'in_asteptare' },
    newValues: { status: 'respins', motiv_respingere: reason },
    metadata: { id_elev: request.id_elev },
  }),

  bulkApprove: (count, requestIds) => logAuditEvent({
    actionType: 'BULK_APPROVE',
    actionDescription: `Aprobare în masă: ${count} cereri`,
    entityType: 'credit_request',
    entityId: 'bulk',
    entityName: `${count} cereri aprobate`,
    newValues: { approved_count: count },
    metadata: { request_ids: requestIds },
  }),

  // schimbare clasa
  changeClass: (student, oldClass, newClass, reason) => logAuditEvent({
    actionType: 'UPDATE',
    actionDescription: `Schimbare clasă: ${oldClass} → ${newClass} (${reason})`,
    entityType: 'class_change',
    entityId: student.id,
    entityName: `${student.prenume} ${student.nume}`,
    oldValues: { clasa: oldClass },
    newValues: { clasa: newClass, motiv: reason },
  }),

  // beneficii
  useBenefit: (student, benefit, credits) => logAuditEvent({
    actionType: 'CREATE',
    actionDescription: `Utilizare beneficiu: ${benefit.nume}`,
    entityType: 'benefit_usage',
    entityId: benefit.id,
    entityName: benefit.nume,
    newValues: { credite_utilizate: credits },
    metadata: { id_elev: student.id, elev_nume: `${student.prenume} ${student.nume}` },
  }),

  // import credite
  importCredits: (count) => logAuditEvent({
    actionType: 'CREATE',
    actionDescription: `Import credite pentru ${count} elevi`,
    entityType: 'credit_import',
    entityId: 'bulk',
    entityName: `Import ${count} elevi`,
    newValues: { imported_count: count },
  }),
};

export default logAuditEvent;
